const name = 'HeaderMoveCustom';
const EASE_DEFAULT = 'Linear.easeNone';
const properties = {
    schema: {
        duration: {
            type: 'number',
            min: 0,
            default: 0,
        },
        delay: {
            type: 'number',
            min: 0,
            default: 0,
        },
    },
};
function animate(kit, elements, duration, delay, { to = {}, ease = EASE_DEFAULT, ...params }) {
    const sequence = kit.sequence(params);
    sequence.add(kit.animate('BasePosition', elements, duration, delay, { to, ease }));
    return sequence.get();
}
export { name, properties, animate };
//# sourceMappingURL=HeaderMoveCustom.js.map